
<div class="container" [ngClass]="{'general-disabled': deployment?.isMigrationActive}">
  <div class="row step-description-block">
    <div class="col">
      <p>Send configuration data to Supplies Mapping Service</p>
    </div>
  </div>
  <div class="row" *ngIf="!loading">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row" *ngIf="!loading &amp;&amp; smsApiSuccess &amp;&amp; !error">
    <div class="col">
      <div class="alert alert-success"><span>{{ smsApiSuccess }}</span></div>
    </div>
  </div>
  <div class="row" *ngIf="!loading">
    <div class="col"> </div>
    <div class="col"><a class="btn btn-primary btn-block" href="javascript:void(0)" (click)="sendToSms()" *ngIf="!disableSmsSend"><span class="oi oi-envelope-closed"></span> Export Supply Configuration</a></div>
    <div class="col"> </div>
  </div>
</div>